import { useTranslation } from '@eti/providers';
import SegmentPanel from './segment-panel/SegmentPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const UnavailableSegment = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(SegmentPanel, {
    content: t('Product.SeatMap.Segment.Unavailable.Content'),
    icons: [[{
      id: 'c_flat-seat-selected-blue',
      size: '32px'
    }, {
      id: 'ban',
      color: '#fff',
      width: '31px',
      height: '19px',
      top: '4px'
    }]],
    title: t('Product.SeatMap.Segment.Unavailable.Title')
  });
};
UnavailableSegment.propTypes = {};
export default UnavailableSegment;
//# sourceMappingURL=UnavailableSegment.js.map